/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    alternative: { type: 'variant', values: [ true ] },
    disabled: { type: 'variant', values: [ true ] },
    focus: { type: 'variant', values: [ true ] },
    hover: { type: 'variant', values: [ true ] },
    pressed: { type: 'variant', values: [ true ] }
  },
  rules: [
    {
      if: { alternative: true },
      tokens: { paddingBottom: 8, paddingTop: 8 }
    },
    {
      if: { hover: true },
      tokens: { inputBackgroundColor: '#f4f4f7' }
    },
    {
      if: { disabled: true },
      tokens: { inputBackgroundColor: '#fafafa', textColor: '#b2b9bf' }
    },
    {
      if: { pressed: true },
      tokens: { inputBackgroundColor: '#b2b9bf' }
    },
    {
      if: { focus: true },
      tokens: { inputBorderColor: '#676e73', inputBorderWidth: 3 }
    }
  ],
  tokens: {
    fontSize: 16,
    inputBackgroundColor: '#ffffff',
    inputBorderColor: '#676e73',
    inputBorderWidth: 1,
    inputWidth: 64,
    lineHeight: 1.5,
    padding: 12,
    paddingBottom: 12,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 12,
    textColor: '#414547'
  }
}
export default theme
